import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
const faqs = [
  {
    question: "Why is it free?",
    answer: "AwayFX is a passion project built to solve a personal problem. I believe core utility tools should be accessible without being exploitative. There are no ads, no hidden costs, and no data harvesting."
  },
  {
    question: "Where do currency rates come from?",
    answer: "We use official exchange rates provided by the European Central Bank via the Frankfurter API. Rates are updated daily on workdays."
  },
  {
    question: "Does it work offline?",
    answer: "Yes. The app caches the latest rates every time you open it with an internet connection. When you're offline, it uses those cached rates - perfect for international travel without a data plan."
  },
  {
    question: "Is my data tracked?",
    answer: "Absolutely not. AwayFX is privacy-first. Your saved expenses and preferences stay on your device. We do not have a server that stores your personal information."
  }
];
export function FaqSection() {
  return (
    <section className="py-24 bg-white dark:bg-zinc-950">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-14">
          <div className="text-xs font-bold tracking-[0.12em] uppercase text-[#6750A4] mb-3">FAQs</div>
          <h2 className="text-[clamp(32px,3.5vw,48px)] font-extrabold tracking-[-0.03em] leading-[1.1] text-[#1D1B20] dark:text-white">
            Good questions.
          </h2>
        </div>
        <div className="max-w-[720px] mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((faq, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="rounded-[20px] overflow-hidden px-7 bg-[#FEF7FF] dark:bg-[#1C1B1F] border border-[#E7E0EC] dark:border-[#2B2930]"
              >
                <AccordionTrigger className="text-[17px] font-semibold text-[#1D1B20] dark:text-[#E6E1E5] hover:no-underline tracking-[-0.01em] py-[22px]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-[#79747E] dark:text-[#C9C3CF] leading-[1.7] pb-[22px]">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
